import * as React from "react"

const SvgAddressBook = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5.5 23a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4.5 22a.97.97 0 0 1 .287-.713A.97.97 0 0 1 5.5 21h14a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712A.97.97 0 0 1 19.5 23zm0-20a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4.5 2q0-.425.287-.713A.97.97 0 0 1 5.5 1h14a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712A.97.97 0 0 1 19.5 3zm7 10q1.25 0 2.125-.875A2.9 2.9 0 0 0 15.5 10q0-1.25-.875-2.125A2.9 2.9 0 0 0 12.5 7q-1.25 0-2.125.875A2.9 2.9 0 0 0 9.5 10q0 1.25.875 2.125A2.9 2.9 0 0 0 12.5 13m-8 7q-.824 0-1.413-.588A1.93 1.93 0 0 1 2.5 18V6q0-.825.587-1.413A1.93 1.93 0 0 1 4.5 4h16q.824 0 1.413.587.587.588.587 1.413v12q0 .825-.587 1.412A1.93 1.93 0 0 1 20.5 20zm1.75-2a8.1 8.1 0 0 1 2.725-2.2q1.6-.8 3.525-.8c1.925 0 2.458.267 3.525.8A8.1 8.1 0 0 1 18.75 18h1.75V6h-16v12zm2.95 0h6.6a5.5 5.5 0 0 0-1.563-.75A6 6 0 0 0 12.5 17q-.9 0-1.738.25A5.5 5.5 0 0 0 9.2 18m3.3-7a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11.5 10q0-.425.287-.713A.97.97 0 0 1 12.5 9q.424 0 .713.287.287.288.287.713c0 .425-.096.52-.287.712A.97.97 0 0 1 12.5 11" />
  </svg>
)
export default SvgAddressBook
